<template>
  <div class="carousel" id="AboutCarousel">

    <div class="item now desktop" :style="'background-image: url('+ this.banners.img.desktop +');'">
    </div>
    <div class="item now mobile" :style="'background-image: url('+ this.banners.img.mobile +');'">
    </div>
  </div>
</template>

<script>
const desktop = require('@/assets/animation/about/desktop.jpg')
const mobile = require('@/assets/animation/about/mobile.jpg')
export default {
  name: "carousel",
  props: ['type', 'name'],
  data() {
    return {
      nowIndex: 0,
      animate: false,
      clientWidth: 0,
      banners: {
        img: {
          desktop: desktop,
          mobile: mobile,
        }
      },
      timeout: null
    }
  },
  computed: {},
  methods: {},
  mounted: function () {
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
@import 'carousel';
</style>
